// extracted by mini-css-extract-plugin
module.exports = {"controlLink":"src-components-UI-Links-ControlLink-styles-style-module__controlLink--23_Qy"};